import { Slide01Title } from './Slide01Title'
import { Slide02GasLoyalty } from './Slide02GasLoyalty'
import { Slide02Opportunity } from './Slide02Opportunity'
import { Slide03Solution } from './Slide03Solution'
import { SlideValue } from './SlideValue'
import { Slide04Mechanics } from './Slide04Mechanics'
import { SlideWalkthrough } from './SlideWalkthrough'
import { Slide05ROI } from './Slide05ROI'

export const slides = [
  Slide01Title,
  Slide02GasLoyalty,
  Slide02Opportunity,
  Slide03Solution,
  SlideValue,
  Slide04Mechanics,
  SlideWalkthrough,
  Slide05ROI,
]
